<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Kategori Lab'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'lab-categories'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/lab-categories/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kategori Lab", route: "" },
      { title: "Daftar Kategori Lab", route: "/masters/lab-categories/list" },
      { title: "Tambah" },
    ])
  },

}

</script>